webpackJsonp([107142165995225],{

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(35);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Donate = function (_React$Component) {
	  _inherits(Donate, _React$Component);
	
	  function Donate(props) {
	    _classCallCheck(this, Donate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      hide: 'hide'
	    };
	    return _this;
	  }
	
	  Donate.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('can_embed_loaded', this.show());
	  };
	
	  Donate.prototype.show = function show() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ hide: '' });
	    }, 1000);
	  };
	
	  Donate.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    return _react2.default.createElement(
	      'div',
	      { className: 'donate' },
	      _react2.default.createElement(
	        'div',
	        { className: '' + this.state.hide },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            siteTitle
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: siteDescription }),
	          _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	          _react2.default.createElement('meta', { property: 'og:title', content: 'Contribute to the Stop KM Legal Fund' }),
	          _react2.default.createElement('meta', { property: 'og:description', content: 'Support the legal defence costs stemming from protest, civil disobedience, and direct action activities in opposition to Kinder Morgan' }),
	          _react2.default.createElement('meta', { property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/stopkmlegaldefencefund/static/feather.d671d4bf.jpg' }),
	          _react2.default.createElement('script', { src: 'https://actionnetwork.org/widgets/v3/fundraising/stop-km-legal-defense-fund?format=js&source=widget&css=whitelabel&style=full' }),
	          _react2.default.createElement('link', { rel: 'stylesheet', href: '../static/actionnetwork.css', type: 'text/css' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Donate to the Stop KM Legal Fund'
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement('div', { id: 'can-fundraising-area-stop-km-legal-defense-fund' }),
	          _react2.default.createElement('div', { className: 'clear' }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'noUnderline', to: '/' },
	            _react2.default.createElement('i', { className: 'fa fa-arrow-left' }),
	            ' Back'
	          ),
	          _react2.default.createElement(_Footer2.default, null)
	        )
	      )
	    );
	  };
	
	  return Donate;
	}(_react2.default.Component);
	
	Donate.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Donate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-donate-js-9a1a1c7d7a2beb677362.js